<template>
  <section>
    <div class="top-banner" :style="isDarkMode ? 'background: black' : ''">
      <Adsense type="banner" ad-slot="8048142417" />
    </div>
    <section class="container">
      <div style="display: flex; position: relative">
        <div>
          <Title title="시그널 실시간 검색어" desc="현재 기준 사용자가 가장 많이 검색 하는 키워드입니다." />
          <span style="font-size: 14px; color: #77b6b1; font-weight: bold">{{ date }}</span>
        </div>
        <v-spacer />
        <div style="display: flex; flex-direction: column; justify-content: center; align-items: center">
          <DarkModeSwitch @switched="onDarkModeSwitched" :initialState="isDarkMode" />
          <GuideImage :isDarkMode="isDarkMode" />
        </div>
      </div>
      <RankTop10 :rankItem="top10" :isLoading="isLoading" />
    </section>
    <div class="divider" :style="isDarkMode ? 'background: black' : ''" />
    <div style="background-color: aliceblue;">
      <img loading="lazy" src="~@/assets/img/banner/signal-app.png" style="width: 100%; cursor: pointer" @click="clickTopBanner" />
      <div class="divider" :style="isDarkMode ? 'background: black' : ''" />
    </div> 
    <section v-if="isLoading" class="container">
      <ArticleSkeleton :rows="10" />
    </section>
    <section v-if="this.naverArticleList.length" class="container">
      <NaverPressArticles :naverArticles="naverArticleList" />
      <div class="banner-bg" :style="isDarkMode ? 'background: black' : ''">
        <Adsense ad-slot="9367006636" />
      </div>
    </section>
    <section v-if="articleList.length" class="container">
      <Title class="mb10" title="인기 뉴스" desc="누적 기준 사용자가 가장 많이 보고 있는 뉴스입니다." />
      <div v-for="(item, index) in articleList" :key="`article-${index}`">
        <ArticleItem :item="item" :index="index" />
        <div v-if="index == 4" class="banner-bg" :style="isDarkMode ? 'background: black' : ''">
          <Adsense ad-slot="4945582339" />
        </div>
      </div>
    </section>
    <div class="divider" :style="isDarkMode ? 'background: black' : ''" />
    <div id="taboola-thumbnails-a" :style="isDarkMode ? 'background: black;' : ''"></div>
    <div class="naver-outer"><div class="nv-openmain" data-title="Signal" data-type="W2"></div></div>
  </section>
</template>

<script>
import * as API from "../../api"
import Title from "./Title"
import ArticleItem from "./ArticleItem"
import RankTop10 from "./RankTop10"
import ArticleSkeleton from "./ArticleSkeleton"
import NaverPressArticles from "./NaverPressArticles"
import Adsense from "./Adsense"
import DarkModeSwitch from "vue-dark-mode-switch"
import GuideImage from "../GuideImage"
import "vue-dark-mode-switch/dist/vue-dark-mode-switch.css"

import { mapGetters, mapMutations } from "vuex"
const RE_TRY_LIMIT = 3

export default {
  components: {
    Title,
    ArticleItem,
    RankTop10,
    NaverPressArticles,
    ArticleSkeleton,
    Adsense,
    DarkModeSwitch,
    GuideImage
  },
  data() {
    return {
      date: "",
      articleList: [],
      naverArticleList: [],
      top10: [],
      isMobile: false,
      timeInterval: null,
      newsInterval: null,
      retryCount: 0,
      bannerVisible: false,
      isLoading: false
    }
  },
  computed: {
    ...mapGetters({ isDarkMode: "isDarkMode" })
  },
  created() {
    gtag("event", "current-theme-mode", {
      theme_mode: this.isDarkMode ? "dark" : "light"
    })

    this.setInterval()
    this.setNaverButton()
    this.initTaboola()
    this.setTimes()
    this.fetch()
  },
  beforeDestroy() {
    clearInterval(this.timeInterval)
    clearInterval(this.newsInterval)
  },
  methods: {
    ...mapMutations({ setThemeMode: "setThemeMode" }),
    initTaboola() {
      window._taboola = window._taboola || []
      _taboola.push({ article: "auto" })
      _taboola.push({
        mode: "thumbnails-a",
        container: "taboola-thumbnails-a",
        placement: "Below Article Thumbnails",
        target_type: "mix"
      })
      _taboola.push({ flush: true })
    },
    controlModal(state) {
      this.isModalOpen = state
    },
    setInterval() {
      this.timeInterval = setInterval(() => {
        this.setTimes()
      }, 1000)
      this.newsInterval = setInterval(() => {
        this.fetch()
      }, 600000)
    },
    setNaverButton() {
      !(function (e, n) {
        let t,
          a = e.getElementsByTagName(n),
          r = a[0],
          s = e.createElement(n),
          c = /(https?:\/\/(test-)?openmain\.(m\.naver\.com|pstatic\.net)\/js\/)openmain\.js/
        for (let o in a) null !== c.exec(a[o].src) && (t = c.exec(a[o].src))
        null == t ||
          (null != t && t.length < 2) ||
          ((s.src = t[1] + "openmainBtn.js?" + Math.round(new Date() / 6e5)), r.parentNode.insertBefore(s, r))
      })(document, "script")
    },
    setTimes() {
      let now = new Date()
      now.setHours(now.getHours())
      const options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        hour12: true,
        minute: "numeric"
      }
      this.date = now.toLocaleDateString("ko-KR", options)
    },
    async fetch() {
      try {
        this.isLoading = true
        this.retryCount += 1
        const response = this.retryCount >= RE_TRY_LIMIT - 1 ? await API.getTestRealtime() : await API.getRealtime()
        this.top10 = response.data.top10
        if (!location.hostname.includes("test")) {
          this.top10 = this.top10.slice(0, 10)
        }
        const naverArticles = response.data.naver?.length > 0 ? response.data.naver : []
        this.articleList = response.data.articles
        this.naverArticleList = naverArticles
        this.bannerVisible = response.data.bannerVisible
        this.retryCount = 0
        this.$emit("onFetchStatus", true)
      } catch (e) {
        if (this.retryCount > RE_TRY_LIMIT) {
          this.retryCount = 0
          this.$emit("onFetchStatus", false)
        } else {
          this.fetch()
        }
      } finally {
        this.isLoading = false
      }
    },
    link(l) {
      window.open(l)
    },
    onSignalSurveyClick() {
      window.open("https://docs.google.com/forms/d/e/1FAIpQLSdf-tbuCVMJFskQbep9Es9F2kvhLsT2FZGSrvCe1CVszOU8HQ/viewform?usp=sf_link")
    },
    onSmartStoreClick() {
      gtag("event", "smart-store-click")
      this.link("https://url.kr/zoahwf")
    },
    copyLink() {
      this.$copyText("https://www.signal.bz/news/guide").then(
        () => this.$showToast("공유 링크가 복사 되었습니다."),
        () => this.$showToast("공유 링크 복사에 실패 했습니다.")
      )
      gtag("event", "copy-link")
    },
    clickTopBanner() {
      gtag("event", "click-top-banner")
      this.link("https://vo.la/x9VkfEe")
    },
    onDarkModeSwitched(isSwitched) {
      gtag("event", "switch-dark-mode", {
        value: this.isDarkMode ? "dark" : "light"
      })
      isSwitched ? this.setThemeMode("dark") : this.setThemeMode("light")
    }
  }
}
</script>
<style lang="scss">
@import "../../assets/css/history-chart.css";
@import "../../assets/uicon/css/uicons-regular-rounded.css";
.news-container {
  background-color: white;
  width: 100%;
  height: 100%;
  overflow-y: auto;
}

.divider {
  margin: 0 auto;
  padding: 5px;
  background-color: #eaeef3;
}
.naver-outer {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  @include desktop {
    display: none;
  }
}
.nv-openmain {
  margin-bottom: 30px;
}
.adwrapper {
  display: flex;
  justify-content: center;
  height: 200px;
}

.top-banner {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f1f3f9;
  width: 100%;
  padding-top: 8px;
}
#taboola-thumbnails-a {
  display: flex;
  max-width: $desktop-width;
  margin: 0 auto;
  padding: 0 30px;
}
.banner-bg {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f1f3f9;
  margin-bottom: 15px;
  padding-top: 8px;
}

.thumbnails-a .syndicatedItem .video-title {
  color: #aeaeae !important;
}
</style>
